define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.urls = void 0;
    var urls = /** @class */ (function () {
        function urls() {
        }
        urls.getIdFromUrl = function () {
            var browserPath = urls.trimTrailingSlash(window.location.pathname);
            var pathArray = browserPath.split('/');
            var lastParam = pathArray[pathArray.length - 1];
            var id = parseInt(lastParam, 10);
            return isNaN(id) ? 0 : id;
        };
        urls.getStringIdFromUrl = function () {
            var browserPath = urls.trimTrailingSlash(window.location.pathname);
            var pathArray = browserPath.split('/');
            var lastParam = pathArray[pathArray.length - 1];
            return lastParam;
        };
        urls.getIdFromQueryString = function () {
            var value = urls.getQueryString('id'), id = parseInt(value, 10);
            return isNaN(id) ? 0 : id;
        };
        urls.getStringIdFromQueryString = function () {
            var value = urls.getQueryString('id');
            return value;
        };
        urls.getNumberFromQueryString = function (name) {
            var value = urls.getQueryString(name), id = parseInt(value, 10);
            return isNaN(id) ? 0 : id;
        };
        urls.is = function (path) {
            var browserPath = urls.trimTrailingSlash(window.location.pathname.toLowerCase());
            path = urls.trimTrailingSlash(path.toLowerCase());
            return browserPath === path;
        };
        urls.getQueryString = function (name) {
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(window.location.search);
            return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        };
        urls.startsWith = function (path) {
            var browserPath = urls.trimTrailingSlash(window.location.pathname.toLowerCase());
            path = urls.trimTrailingSlash(path.toLowerCase());
            return browserPath.indexOf(path) === 0;
        };
        urls.trimTrailingSlash = function (value) {
            return value.replace(/\/$/, '');
        };
        urls.customerList = '/customers/index';
        urls.customerDetails = '/customers/edit';
        urls.customerGetCustomerById = '/customers/GetCustomerById';
        urls.customerGetLookupData = '/customers/GetCustomerLookupData';
        urls.customerGetCustomerNotes = '/CustomerNotes/GetCustomerNotes';
        urls.customerSaveCustomerNotes = '/CustomerNotes/SaveCustomerNotes';
        urls.getPhoneNumberById = '/PhoneNumbers/PhoneNumberById';
        urls.getPhoneGetLookupData = '/PhoneNumbers/GetPhoneLookupData';
        urls.getPbxExtensionDependencies = '/CustomerPbx/GetExtensionDependencies';
        urls.getCustomerLocationById = '/OfficeLocations/getCustomerLocationById';
        urls.getCustomerAccountById = '/CustomerAccounts/getCustomerAccountById';
        urls.getTodoById = '/ToDo/getTodoById';
        urls.getTodoGetLookupData = '/ToDo/GetTodoLookupData';
        urls.phoneNumberDetails = '/PhoneNumbers/Details';
        urls.phoneNumberProviderDetails = '/phoneNumberProviders/details';
        urls.phoneNumberProvidersGetById = '/phoneNumberProviders/GetById';
        return urls;
    }());
    exports.urls = urls;
});
//# sourceMappingURL=urls.js.map


//////////////////
// WEBPACK FOOTER
// ./build/utils/urls.js
// module id = 7
// module chunks = 2